import { render } from "./ResultsMobilenew.vue?vue&type=template&id=6c8af5e2&scoped=true"
import script from "./ResultsMobilenew.vue?vue&type=script&lang=js"
export * from "./ResultsMobilenew.vue?vue&type=script&lang=js"

import "./ResultsMobilenew.vue?vue&type=style&index=0&id=6c8af5e2&lang=scss"
import "./ResultsMobilenew.vue?vue&type=style&index=1&id=6c8af5e2&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2874961510/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8af5e2"]])

export default __exports__